import React from 'react';
import './EmptyState.css';

export default function EmptyState({ icon = '📭', title, description, action }) {
  return (
    <div className="empty-state">
      <div className="es-icon">{icon}</div>
      {title       && <p className="es-title">{title}</p>}
      {description && <p className="es-desc">{description}</p>}
      {action && (
        <button className="es-action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
